import { useRoute } from "@react-navigation/native";
import { ScrollView } from "native-base";
import React, { useEffect, useState } from "react";
import { Platform } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { AppScreen } from "../../components";
import LoadingIndicator from "../../components/LoadingIndicator";
import { getPage } from "../../redux/slices/PageSlice";
import InfoPages from "./InfoPages";
import Login from "./Login";
import StoreRegistration from "./StoreRegistration";
import Wizard from "./Wizard";

const Home = (props) => {
	const dispatch = useDispatch();

	const page = useSelector((state) => state.Page.Pages);
	const isPageLoading = useSelector((state) => state.Page.loading);

	useEffect(() => {
		try {
			dispatch(getPage(props.route.params.slug));
		} catch (error) {
			ErrorToast(error.message);
		}
	}, [props.route]);

	return (
		<>
			{isPageLoading ? (
				<LoadingIndicator />
			) : (
				<>
					{page.map((component, index) => {
						switch (component.componenttype_name) {
							case "WIZARD":
								return (
									<AppScreen key={component.sitepagecomponent_guid}>
										<Wizard {...props} key={index} components={component} />
									</AppScreen>
								);
							case "FORM":
								switch (props.route.params.slug) {
									case "login":
										return (
											// <AppScreen>
											<ScrollView
												key={component.sitepagecomponent_guid}
												style={
													Platform.OS !== "web"
														? {
																flex: 1,
																backgroundColor: "#fff",
														  }
														: {}
												}
											>
												<Login {...props} key={index} components={component} />
											</ScrollView>
											// </AppScreen>
										);
									case "register-store":
										return (
											<AppScreen key={component.sitepagecomponent_guid}>
												<StoreRegistration
													{...props}
													key={index}
													components={component}
												/>
											</AppScreen>
										);

									default:
										break;
								}
						}
					})}
					{page.length <= 0 && <InfoPages {...props} />}
				</>

				// <>
				// 	{(() => {
				// 		switch (props.route.params.slug) {
				// 			case "register-store":
				// 				return (
				// 					<AppScreen>
				// 						<StoreRegistration {...props} components={page[0]} />
				// 					</AppScreen>
				// 				);
				// 			case "login":
				// 				return (
				// 					// <AppScreen>
				// 					<ScrollView
				// 						style={
				// 							Platform.OS !== "web"
				// 								? {
				// 										flex: 1,
				// 										backgroundColor: "#fff",
				// 								  }
				// 								: {}
				// 						}
				// 					>
				// 						<Login {...props} components={page[0]} />
				// 					</ScrollView>
				// 					// </AppScreen>
				// 				);
				// 			case "register":
				// 				return (
				// 					<AppScreen>
				// 						<Wizard {...props} components={page[0]} />
				// 					</AppScreen>
				// 				);

				// 			default:
				// 				return <InfoPages {...props} />;
				// 		}
				// 	})()}
				// </>
			)}
		</>
	);
};

export default Home;
